var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFilledBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37411 9.89762C2.56315 8.09294 1.19084 5.91227 1.19084 4.11385C1.19084 3.31803 1.46029 2.59741 2.06812 2.01465C2.43783 1.65747 2.86393 1.46948 3.27751 1.46948C3.61589 1.46948 3.92293 1.60107 4.14225 1.90185L5.4895 3.80054C5.69629 4.09505 5.80282 4.33944 5.80282 4.56502C5.80282 4.85327 5.63363 5.10392 5.35791 5.39217L4.913 5.84961C4.84408 5.91854 4.81901 6 4.81901 6.08146C4.81901 6.17546 4.85661 6.26318 4.88794 6.33211C5.08846 6.72062 5.65869 7.38485 6.27279 7.99894C6.89315 8.61304 7.55737 9.18327 7.94588 9.39006C8.00855 9.42139 8.10254 9.45898 8.19653 9.45898C8.278 9.45898 8.36572 9.42765 8.43465 9.35872L8.87956 8.92008C9.16781 8.6381 9.42472 8.47518 9.70671 8.47518C9.93229 8.47518 10.1767 8.57544 10.4712 8.77596L12.3949 10.142C12.6895 10.3551 12.8085 10.6558 12.8085 10.9692C12.8085 11.3953 12.6017 11.8276 12.2696 12.1973C11.6994 12.824 10.9913 13.106 10.1829 13.106C8.38452 13.106 6.18506 11.7086 4.37411 9.89762Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilledBlack);
export default __webpack_public_path__ + "static/media/phone-filled-black.fba01e868941b5f5dce2958fe518a857.svg";
export { ForwardRef as ReactComponent };